import { DateRange, dateRangesOverlap } from 'owa-datetime-utils';
import { EventEntity } from '../schema/EventEntity';

export function getEventsFromCache<T extends EventEntity>(dateRange: DateRange, events: T[]): T[] {
    const returnItems: T[] = [];

    for (const cacheItem of events) {
        const itemRange: DateRange = { start: cacheItem.Start, end: cacheItem.End };
        const rangeOverlap = dateRangesOverlap(dateRange, itemRange, true /* inclusive */);

        if (rangeOverlap === 0) {
            returnItems.push(cacheItem);
        } else if (rangeOverlap > 0) {
            // The item date range has gone past the range in cache, exit
            break;
        }
    }

    return returnItems;
}
